null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js-dom/v1.0.0/src/main/scala/org/scalajs/dom/ext/Extensions.scala